import React from 'react';
import { LogoUploader } from 'swag-client-common/components/logo-uploader';
import { ColorPicker } from 'swag-client-common/components/color-picker';
import { Buttons } from '../buttons';
import css from '../../edit-box-notecard-popup.scss';
export const LogoUploadStepComponent = ({
  boxItemsId,
  logo,
  color,
  isLogoLoading,
  onNext,
  onBack,
  onColorChange,
  onLogoUpload,
  onLogoDelete,
  onProvideDesignLater
}) => {
  const isNextButtonDisabled = Boolean(!logo || !color || isLogoLoading);
  const handleInputLogoChange = e => {
    onLogoUpload(e.target.files[0]);
  };
  const handleColorChange = color => {
    onColorChange(color.hex);
  };
  const handleRemoveColor = () => {
    onColorChange('');
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: css.title
  }, "Let\u2019s design your notecard!"), /*#__PURE__*/React.createElement("div", {
    className: css.subTitle
  }, "Upload your logo and select your brand color. You will then be able to add your custom text. You can also upload your own design."), /*#__PURE__*/React.createElement("div", {
    className: css.content
  }, /*#__PURE__*/React.createElement(LogoUploader, {
    isLogoDeletable: true,
    isLoading: isLogoLoading,
    logoWrapperClassName: css.logoWrapper,
    logoBlockClassName: css.logoBlock,
    handleLogoChange: handleInputLogoChange,
    handleDeleteLogo: onLogoDelete,
    currentLogo: logo,
    buttonText: logo ? 'Change logo' : 'Upload your logo'
  }), /*#__PURE__*/React.createElement(ColorPicker, {
    currentColor: color,
    handleColorChange: handleColorChange,
    handleRemoveColor: handleRemoveColor,
    colorBlockClassName: css.colorBlock,
    colorLabelClassName: css.colorLabel,
    headline: "Pick a brand color"
  })), /*#__PURE__*/React.createElement("div", {
    onClick: onProvideDesignLater,
    className: css.pinkLink
  }, "I want to do this later and send over my design"), /*#__PURE__*/React.createElement(Buttons, {
    nextButtonDisabled: isNextButtonDisabled,
    nextText: "Continue",
    backText: "I Don't Want A Notecard",
    onNextButton: onNext,
    onBackButton: () => onBack(boxItemsId)
  }));
};